import {
  Component, OnInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { take } from 'rxjs/operators';
import { FiservPosPaymentService } from '../../services/fiserv-pos-payment.service';
import { FiservClinicTerminal } from '../../../models/fiserv.models';

@Component({
  selector: 'fiserv-pos-devices',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './fiserv-pos-devices.component.html',
  styleUrls: ['./fiserv-pos-devices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiservPosDevicesComponent implements OnInit {
  terminals: FiservClinicTerminal[] = [];
  loading = false;

  pingStatus: Record<string, boolean | null> = {};  // hsn → true/false/null
  pingingHsn: string | null = null;

  // Register new terminal
  showRegisterForm = false;
  registering = false;
  newHsn = '';
  newLabel = '';
  newModel: 'Clover' | 'Ingenico' | '' = '';
  removingId: number | null = null;

  constructor(
    private posService: FiservPosPaymentService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void { this.loadTerminals(); }

  loadTerminals(): void {
    this.loading = true;
    this.posService.getTerminals().pipe(take(1)).subscribe({
      next: terminals => {
        this.terminals = terminals;
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdr.markForCheck();
      },
    });
  }

  pingTerminal(hsn: string): void {
    this.pingingHsn = hsn;
    this.pingStatus[hsn] = null;
    this.cdr.markForCheck();
    this.posService.pingTerminal(hsn).pipe(take(1)).subscribe({
      next: r => {
        this.pingStatus[hsn] = r.connected;
        this.pingingHsn = null;
        this.cdr.markForCheck();
      },
      error: () => {
        this.pingStatus[hsn] = false;
        this.pingingHsn = null;
        this.cdr.markForCheck();
      },
    });
  }

  pingAll(): void {
    this.terminals.forEach(t => this.pingTerminal(t.hsn));
  }

  openRegisterForm(): void {
    this.showRegisterForm = true;
    this.newHsn = '';
    this.newLabel = '';
    this.newModel = '';
  }

  cancelRegister(): void {
    this.showRegisterForm = false;
  }

  registerTerminal(): void {
    if (!this.newHsn.trim() || !this.newLabel.trim() || !this.newModel) {
      return; // button disabled handles this
    }
    this.registering = true;
    this.posService.registerTerminal({
      hsn:           this.newHsn.trim(),
      label:         this.newLabel.trim(),
      terminalModel: this.newModel,
    }).pipe(take(1)).subscribe({
      next: () => {
        this.registering = false;
        this.showRegisterForm = false;
        this.loadTerminals();
        this.cdr.markForCheck();
      },
      error: () => {
        this.registering = false;
        this.cdr.markForCheck();
      },
    });
  }

  removeTerminal(terminal: FiservClinicTerminal): void {
    if (!confirm(`Remove terminal "${terminal.label ?? terminal.hsn}"?`)) return;
    this.removingId = terminal.id;
    this.cdr.markForCheck();
    this.posService.removeTerminal(terminal.id).pipe(take(1)).subscribe({
      next: () => {
        this.removingId = null;
        this.loadTerminals();
        this.cdr.markForCheck();
      },
      error: () => {
        this.removingId = null;
        this.cdr.markForCheck();
      },
    });
  }

  trackByHsn(_i: number, t: FiservClinicTerminal): string { return t.hsn; }
}
